module.exports = __webpack_public_path__ + "media/mindshift.c6c1ef1e.mp3";